import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { changeDeal } from 'bundles/apex/deals/form/store/deal/actions';

export default function DealField(Component, staticName) {
  const Field = ({ deal, changeDeal, fields, invalidFields = [], name = staticName, ...props }) => {
    const field = fields[name];
    if (!field || field.hidden) {
      return null;
    }

    return (
      <Component
        changeDeal={changeDeal}
        deal={deal}
        invalid={(invalidFields).indexOf(name) !== -1}
        label={field.label}
        name={name}
        options={field.options}
        required={field.required}
        {...props}
      />
    );
  };

  Field.propTypes = {
    changeDeal: PropTypes.func.isRequired,
    deal: PropTypes.object.isRequired,
    fields: PropTypes.objectOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      required: PropTypes.bool,
    })).isRequired,
    invalidFields: PropTypes.array,
    name: PropTypes.string,
  };

  return connect(mapStateToProps, mapDispatchToProps)(Field);
}

export const propTypes = {
  changeDeal: PropTypes.func.isRequired,
  deal: PropTypes.object.isRequired,
  invalid: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  options: PropTypes.array,
  required: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  deal: state.deal,
  fields: state.fields,
  invalidFields: state.invalidFields,
});

const mapDispatchToProps = {
  changeDeal
};
